import { useContext } from 'react'

import { AuthContext } from 'context/AuthContext'

/**
 * Returns the auth context {AuthContext} via hook
 */
export default function useAuth() {
  const authContext = useContext(AuthContext)
  return authContext
}
